import React, { Component, Fragment } from "react";
import { Route, Link, withRouter } from "react-router-dom";
import Book from "../book/Book";
import "./app.css";
import Nav from "../nav/Nav.js";
import Loader from "../../components/Loader";
import Dash from "../dash/Dash";
import library from "../../data/library";
import HomeStyled from "./HomeStyled";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      theme: "dark",
      loading: false,
      book: null
    };
  }

  componentWillReceiveProps = (nextProps, nextState) => {
    //redirect from non-home entry
    const { state } = nextProps.history.location;
    if (state !== undefined) {
      this.chooseBook(state.book, state.chapter, state.section);
    }
    if (this.state.book) {
      this.setState({ loading: false });
    }
  }
  setTheme = () => {
    if (this.state.theme === "light") {
      this.setState({ theme: "dark" });
    } else {
      this.setState({ theme: "light" });
    }
  }
  chooseBook = async (id, first, section) => {
    this.setState({loading: true})
    const { utils, history } = this.props;
    let result = await utils.fb.getFullBook(id);
    this.setState({
      book: result
    });
    if (this.state.book){
      this.setState({loading: false})
      const location = { pathname: `/${id}/${first}/${section}` };
      history.push(location);
    }
  };
  render = () => {
    const { utils } = this.props;
    const { book, theme } = this.state;

    // Components for Routes
    const CurrentBook = ({ location, match, history }) => (
      <Book
        book={book}
        match={match}
        history={history}
        location={location}
        theme={theme}
        utils={utils}
      />
    );

    const Dashboard = ({ location }) => (
      <Dash
        location={location}
        library={library}
        chooseBook={this.chooseBook}
        theme={theme}
      />
    );

    return (
      <HomeStyled theme={theme}>
        {this.state.loading && <Loader theme={theme}> ... </Loader>}
        {!this.state.loading && (
          <Fragment>
            <Nav theme={theme} setTheme={this.setTheme.bind(this)} />
            <Route exact path="/" component={Dashboard} />
            <Route path="/:book/:chapter/:section" component={CurrentBook} />
          </Fragment>
        )}
      </HomeStyled>
    );
  }
}

const HomeWR = withRouter(Home);
export default HomeWR;



// WEBPACK FOOTER //
// ./src/containers/home/Home.js